module.exports = __webpack_public_path__ + "static/media/20c-01-HOME_ST-2020-1595x203mm-oleo-sobre-madera.b27dff87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20c/20c-01-HOME_ST-2020-1595x203mm-oleo-sobre-madera.jpg
// module id = 252
// module chunks = 0